export { default as default } from './KitModalV2';
